import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Upload, Loader2, Image as ImageIcon } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ImageUploadField = ({ value, onChange, getAuthHeaders, label = "Imagem" }) => {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      alert('Apenas imagens JPG, PNG, GIF ou WEBP são permitidas');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('A imagem deve ter no máximo 5MB');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const resp = await axios.post(`${API}/admin/uploads/image`, formData, {
        headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' },
      });
      const fullUrl = `${BACKEND_URL}${resp.data.url}`;
      onChange(fullUrl);
    } catch (err) {
      alert(err.response?.data?.detail || 'Erro ao fazer upload da imagem');
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const getImageSrc = (url) => {
    if (!url) return '';
    if (url.startsWith('data:') || url.startsWith('http')) return url;
    return `${BACKEND_URL}${url}`;
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-white">{label}</label>
      <div className="flex gap-2">
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="URL da imagem ou faça upload..."
          className="bg-black border-[#cc8b3a]/30 text-white flex-1"
        />
        <label className="cursor-pointer">
          <div className={`inline-flex items-center justify-center rounded-md text-sm font-bold transition-colors bg-[#cc8b3a] hover:bg-[#d4af37] text-black h-10 px-3 ${uploading ? 'opacity-50 pointer-events-none' : ''}`}>
            {uploading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <Upload className="w-4 h-4" />
            )}
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png,image/gif,image/webp"
            onChange={handleUpload}
            disabled={uploading}
            className="hidden"
          />
        </label>
      </div>
      {value && (
        <div className="mt-2 relative w-full aspect-video rounded-lg overflow-hidden bg-black/30 border border-[#cc8b3a]/20">
          <img
            src={getImageSrc(value)}
            alt="Preview"
            className="w-full h-full object-cover"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageUploadField;
